import React from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import { formattedNumber } from '../../../../../../utils/formatterHelpers';

const LineSavings = (props) => {
    const {
        annualResults,
        showPPA,
        showLoan,
        showOBS,
        showCAP,
        cashprice,
        resiToggle,
        includeCash,
        loanProvider,
    } = props;

    const years = Object.keys(annualResults);
    const utilityArray = [];
    let ppaSavings = [];
    let loanSavings = [];
    let cashSavings = [];
    let obsSavings = [];
    let capSavings = [];
    let mosaicSavings = [];

    for (const year of years) {
        utilityArray.push(-formattedNumber(annualResults[year].cumuluativeSolarSavings.toFixed(0)));
        ppaSavings.push(formattedNumber((annualResults[year].cummulativePPABill * -1).toFixed(0)));
        obsSavings.push(formattedNumber(annualResults[year].cumulativeOBSSavings.toFixed(0)));
        loanSavings.push(formattedNumber(annualResults[year].cumulativeLoanSavings.toFixed(0)));
        mosaicSavings.push(formattedNumber(annualResults[year].cumulativeMosaicSavings.toFixed(0)));
        cashSavings.push(formattedNumber(annualResults[year].cumulativeCashSavings.toFixed(0)));
        capSavings.push(formattedNumber(annualResults[year].cumulativeCAPSavings.toFixed(0)));
    }

    if (showLoan === false || loanProvider === 'mosaic') {
        loanSavings = [];
    }

    if ((showLoan && loanProvider !== 'mosaic') || resiToggle === false || !showLoan) {
        mosaicSavings = [];
    }

    if (showPPA === false || resiToggle) {
        ppaSavings = [];
    }
    if (showOBS === false || cashprice < 500000) {
        obsSavings = [];
    }
    if (showCAP === false || resiToggle) {
        capSavings = [];
    }
    if (includeCash === false) {
        cashSavings = [];
    }

    const data = {
        datasets: [
            {
                label: 'Utility (Value of Solar)',
                data: utilityArray,
                backgroundColor: '#db4141',
                fill: false,
                lineTension: 0.1,
                pointRadius: 2,
                pointHoverRadius: 3,
                borderJoinStyle: 'miter',
                borderColor: '#db4141',
                pointHoverBorderWidth: 2,
            },
            {
                label: 'PPA',
                data: ppaSavings,
                backgroundColor: ['#1857B5'],
                fill: false,
                lineTension: 0.1,
                pointRadius: 2,
                pointHoverRadius: 5,
                borderJoinStyle: 'miter',
                borderColor: '#1857B5',
                pointHoverBorderWidth: 2,
            },
            {
                label: 'Loan',
                data: loanSavings,
                backgroundColor: ['#01B5D2'],
                fill: false,
                lineTension: 0.1,
                pointRadius: 2,
                pointHoverRadius: 5,
                borderJoinStyle: 'miter',
                borderColor: '#01B5D2',
                pointHoverBorderWidth: 2,
            },
            {
                label: 'Mosaic',
                data: mosaicSavings,
                backgroundColor: ['#2f4653'],
                fill: false,
                lineTension: 0.1,
                pointRadius: 2,
                pointHoverRadius: 5,
                borderJoinStyle: 'miter',
                borderColor: '#2f4653',
                pointHoverBorderWidth: 2,
            },
            {
                label: 'OBS',
                data: obsSavings,
                backgroundColor: ['#f48942'],
                fill: false,
                lineTension: 0.1,
                pointRadius: 2,
                pointHoverRadius: 5,
                borderJoinStyle: 'miter',
                borderColor: '#f48942',
                pointHoverBorderWidth: 2,
            },
            {
                label: 'CAP',
                data: capSavings,
                backgroundColor: ['#a232a8'],
                fill: false,
                lineTension: 0.1,
                pointRadius: 2,
                pointHoverRadius: 5,
                borderJoinStyle: 'miter',
                borderColor: '#a232a8',
                pointHoverBorderWidth: 2,
            },
            {
                label: 'Cash',
                data: cashSavings,
                backgroundColor: ['#05B356'],
                fill: false,
                lineTension: 0.1,
                pointRadius: 2,
                pointHoverRadius: 5,
                borderJoinStyle: 'miter',
                borderColor: '#05B356',
                pointHoverBorderWidth: 2,
            },
        ],
        labels: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
            '13',
            '14',
            '15',
            '16',
            '17',
            '18',
            '19',
            '20',
            '21',
            '22',
            '23',
            '24',
            '25',
            '26',
            '27',
            '28',
            '29',
            '30',
        ],
    };

    return <Line data={data} />;
};

LineSavings.propTypes = {
    annualResults: PropTypes.object.isRequired,
    showPPA: PropTypes.bool.isRequired,
    showLoan: PropTypes.bool.isRequired,
    showOBS: PropTypes.bool.isRequired,
    showCAP: PropTypes.bool.isRequired,
    includeCash: PropTypes.bool.isRequired,
    resiToggle: PropTypes.bool.isRequired,
    cashprice: PropTypes.number.isRequired,
    loanProvider: PropTypes.string.isRequired,
};

export default LineSavings;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/Graphs/LineSavings/LineSavings.js